module.exports = __webpack_public_path__ + "static/fairPricing-b9d777fdf451748288428d077801562f.png";